import React from 'react';
import {BrowserRouter} from "react-router-dom";
import Root from '../Root';

const App = () =>
    <BrowserRouter basename={'/'}>
        <Root/>
    </BrowserRouter>;
export default App;